import React from 'react';
import { bool, func } from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

import DataSettings from './DataSettingsContainer';
import {
  applyDataSettingsDialog,
  cancelDataSettingsDialog,
} from '../actions/dataSettingsDialog';
import { getDataSettingsDialogOpened } from '../selectors/dataSettingsDialog';

const GoldenButton = styled(FlatButton)`
  color: ${({ theme }) => theme.colors.gold500} !important;
`;

export const DataSettingsDialog = ({ open, doCancel, doApply }) => (
  <Dialog
    title="Data Settings"
    actions={[
      <GoldenButton label="Cancel" onClick={doCancel} />,
      <GoldenButton label="Save" onClick={doApply} />,
    ]}
    modal={false}
    open={open}
    onRequestClose={doCancel}
    autoScrollBodyContent={true}
  >
    <DataSettings />
  </Dialog>
);

DataSettingsDialog.propTypes = {
  open: bool.isRequired,
  doCancel: func.isRequired,
  doApply: func.isRequired,
};

export default connect(
  state => ({
    open: getDataSettingsDialogOpened(state),
  }),
  {
    doCancel: cancelDataSettingsDialog,
    doApply: applyDataSettingsDialog,
  },
)(DataSettingsDialog);



// WEBPACK FOOTER //
// ./src/components/DataSettingsDialog.jsx